import type { UseQueryResult } from '@tanstack/react-query';

import { useQuery } from '@tanstack/react-query';

import type { User } from '../../api/types/user.types';
import type { UseUserParams } from './useUser.types';

import { getUser } from '../../api/get-user/getUser';

export function useUser(params: UseUserParams): UseQueryResult<User, Error> {
  return useQuery<User, Error>({
    queryKey: ['users', 'detail', params.organizationId, params.userId],
    queryFn: (): Promise<User> =>
      getUser({
        userId: params.userId,
        organizationId: params.organizationId,
      }),
    enabled: !!params.organizationId && !!params.userId,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
}
